'use strict';

// https://262.ecma-international.org/6.0/#sec-ispropertykey
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
module.exports = function IsPropertyKey(argument) {
  return typeof argument === 'string' || _typeof(argument) === 'symbol';
};